/**
 * Буцаасан гутлыг ХААШАА тавьж болох вэ — `disposition`-оос.
 *
 * Сервер (`services/core/src/modules/orders.ts` → `returnPlacement`) байршил
 * заагаагүй үед `DISPOSITION_MAP`-аас өөрөө олдог: дахин зарах гутал тухайн
 * салбарын лангуунд, гэмтэлтэй нь хорио цээрт, актлагдсан нь устгасан
 * байршилд. Ажилтан гараар сонгохдоо ч ТЭР зарчмыг дагана.
 *
 * Өмнө нь «Хаашаа тавих» сонголтод БҮХ байршил — бусад салбарын лангуу,
 * худалдан авагч, замын байршил хүртэл — гардаг байв (захиалагчийн
 * цэгцлэл №11, 2026-10-05).
 *
 * ⚠️ Энэ нь зөвхөн СОНГОЛТЫН шүүлт. Сервер одоохондоо заасан ямар ч
 *    идэвхтэй байршлыг хүлээн авдаг — серверт ижил шалгалт нэмэх нь
 *    буцаалтын бизнес логикийн өөрчлөлт тул тусад нь шийднэ.
 */
/** Disposition бүрт зөвшөөрөгдөх байршлын төрөл (`LocationType`). */
export const RETURN_LOCATION_TYPES = {
    RESTOCKED: ['SALES_FLOOR', 'DISPLAY', 'BACK_ROOM'],
    DEFECTIVE: ['QUARANTINE', 'REPAIR'],
    RETURN_TO_SUPPLIER: ['QUARANTINE'],
    WRITTEN_OFF: ['DISPOSED'],
};
/**
 * Дахин зарах гутал ЗӨВХӨН буцаалт хүлээн авсан салбарт үлдэнэ — өөр
 * салбар руу явуулах бол шилжүүлгээр (хөдөлгөөн, баримттай). Хорио цээр,
 * засвар, устгасан байршил ихэвчлэн агуулахад байдаг тул салбараар шүүхгүй.
 */
const SAME_STORE_ONLY = new Set(['RESTOCKED']);
/**
 * @param locations  идэвхтэй байршлууд (`GET /ref/locations`)
 * @param storeId    борлуулалт хийсэн салбар
 * @returns          тохирох байршлууд — тухайн салбарынх эхэндээ,
 *                   бусад нь серверийн эрэмбээр
 */
export function returnLocationChoices(locations, disposition, storeId) {
    const types = RETURN_LOCATION_TYPES[disposition];
    const sameStoreOnly = SAME_STORE_ONLY.has(disposition);
    return locations
        .filter((l) => types.includes(l.type) && (!sameStoreOnly || l.storeId === storeId))
        .sort((a, b) => Number(b.storeId === storeId) - Number(a.storeId === storeId));
}
//# sourceMappingURL=return-placement.js.map